import { FC, memo } from 'react'

import { Info, InfoSet } from 'ui/components/Info'
import { Col, Row } from 'ui/themes/globalStyles'

import { CompanyPhysicalAddressFormValue } from '../../types/forms'

type CompanyPhysicalAddressDetailsProps = {
  value: CompanyPhysicalAddressFormValue
}

export const CompanyPhysicalAddressDetails: FC<CompanyPhysicalAddressDetailsProps> = memo(({ value }) => (
  <InfoSet legend="Physical Address">
    <Row>
      <Col>
        <Info label="Street">{value.street}</Info>
      </Col>
      <Col>
        <Info label="City">{value.city}</Info>
      </Col>
    </Row>
    <Row>
      <Col>
        <Info label="State/Province">{value.state}</Info>
      </Col>
      <Col>
        <Info label="Country">{value.country}</Info>
      </Col>
    </Row>
    <Row>
      <Col>
        <Info label="Zip/Postal Code">{value.postalCode}</Info>
      </Col>
    </Row>
  </InfoSet>
))
